import React from 'react';
import { FsHeading } from '@finalsite/wc-react';

export const SectionField = ({ field }) => {
  return <FsHeading type={'title3'}>{field.rendered_prompt}</FsHeading>;
}
